"use client";

import React, { useContext, useEffect, useState } from "react";
import Link from "next/link";
import client from "@/lib/api/client";
import { activeCtx } from "@/lib/api/state";
import { useLayout } from "@/lib/context/layout";

export const LogoElement = () => {
    const { activeContext } = useLayout();
    const [logo, setLogo] = useState("");

    const update = () => {
        const [provider, reseller, client_id] = client.get_context(activeContext);
        client.get_theme_logo(reseller, client_id).then((theme_logo: string) => {
            setLogo(theme_logo);
        });
    };

    useEffect(() => {
        update();
    }, [activeContext]);

    let href = "/";
    const home = (activeCtx.properties as Record<string, { value: string }>)?.home_page;
    if (home) {
        href = home.value;
    }

    return (
        <Link href={href || "/"}>
            {logo ? (
                <img
                    id="root-logo"
                    src={logo}
                    width="100%"
                    alt="logo"
                    style={{ height: "calc(1.75rem * var(--topbar-scale))" }}
                />
            ) : (
                <div style={{ height: "calc(1.75rem * var(--topbar-scale))" }} />
            )}
        </Link>
    );
};
